import ForesightedBuildabilityModal from './ForesightedBuildabilityModal'
import foresightedBuildabilityModalContainer from './foresightedBuildabilityModalContainer'

export default foresightedBuildabilityModalContainer(ForesightedBuildabilityModal)
